import {eatalianoAxios} from "@/data/api/http/axios";
import {JobApplicationDetails, UpdatedJobApplication} from "@/data/entities/jobApplication";

export const getJobApplication = (jobApplicationId: number): Promise<JobApplicationDetails> => (
    eatalianoAxios
        .get(`/careers/job-applications/${jobApplicationId}`)
        .then(response => response.data)
);

export const updateJobApplication = (
    jobApplicationId: number,
    updatedFields: UpdatedJobApplication,
): Promise<JobApplicationDetails> => (
    eatalianoAxios
        .put(`/careers/job-applications/${jobApplicationId}`, updatedFields)
        .then(response => response.data)
);